(function () {
  var params = new URLSearchParams(window.location.search);

  var RESULT_MAP = { fd: 'フリーズドライ', frozen: '冷凍手作りごはん', dry: '国産ドライ', consult: '相談' };
  var AGE_MAP = { puppy: '子犬（1歳未満）', adult: '成犬（1〜7歳）', senior: 'シニア（7歳以上）' };
  var CONCERN_MAP = { appetite: '食いつきが落ちてきた', fat: '脂質・体重の管理', senior: 'シニア期の食事', dry_only: 'ドライだけだと食べない', homemade: '手作りに近いごはん' };
  var USAGE_MAP = { main: '主食として', add: 'トッピングとして', small: '少量から試す', consult: '相談して決める' };
  var FREEZER_MAP = { yes: '余裕がある', little: '少しなら置ける', no: 'むずかしい' };

  function tr(map, key) {
    return (key && map[key]) || key || '';
  }

  var attributes = {};
  var found = false;

  var result = params.get('diag_result');
  if (result) { attributes['診断結果'] = tr(RESULT_MAP, result); found = true; }

  var age = params.get('diag_age');
  if (age) { attributes['診断_年齢'] = tr(AGE_MAP, age); found = true; }

  var concern = params.get('diag_concern');
  if (concern) { attributes['診断_悩み'] = tr(CONCERN_MAP, concern); found = true; }

  var usage = params.get('diag_usage');
  if (usage) { attributes['診断_使い方'] = tr(USAGE_MAP, usage); found = true; }

  var freezer = params.get('diag_freezer');
  if (freezer) { attributes['診断_冷凍庫'] = tr(FREEZER_MAP, freezer); found = true; }

  // 診断ログ（スプレッドシート）のセッションIDと突き合わせるための識別子。
  // 診断ページが付けた "hmg_" で始まる文字列だけを受け付ける。
  var sid = params.get('diag_sid');
  if (sid && /^hmg_[0-9a-z]{6,40}$/.test(sid)) { attributes['診断_ID'] = sid; found = true; }

  if (!found) return;

  // カート属性として保存。注文完了時にShopify管理画面の「追加の詳細」欄に残る。
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).catch(function () {
    // 送信に失敗しても購入導線には影響させない
  });
})();
